export default __webpack_public_path__ + "static/media/bg1.159bc66e.png";